import { canManageAdmins, canManagePersonnel } from '@czas/shared'

import { useSession } from './auth'

export function useCanManageAdmins(): boolean {
  const session = useSession()
  return canManageAdmins(session.data ?? null)
}

export function useCanManagePersonnel(): boolean {
  const session = useSession()
  return canManagePersonnel(session.data ?? null)
}
